
import {
  computed, defineComponent, reactive, ref,
} from 'vue';
import { Input, Checkbox, Button } from 'ant-design-vue';
import { useStore } from 'vuex';

export default defineComponent({
  components: {
    aInput: Input,
    aCheckbox: Checkbox,
    aButton: Button,
  },
  setup() {
    const form = reactive({
      code: '',
      password: '',
    });
    const remember = ref(false);
    const loading = ref(false);
    const store = useStore();
    const softConfig = computed(() => store.state.system.softConfig);
    const login = async () => {
      loading.value = true;
      await store.dispatch('user/login', form).finally(() => {
        loading.value = false;
      });
    };
    return {
      form,
      softConfig,
      login,
      loading,
      remember,
    };
  },
});
